export var usePrefixCls = function (tag, props) {
    var _a;
    var prefix = (_a = props === null || props === void 0 ? void 0 : props.prefix) !== null && _a !== void 0 ? _a : 'cn-ui-m-';
    return "".concat(prefix).concat(tag !== null && tag !== void 0 ? tag : '');
};
